import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetLeaves = async (params?: {
  month?: string;
  search?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/leaves`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load employee leaves.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreateLeave = async (payload: {
  employee_id: string;
  leave_date: string;
  leave_type: string;
  notes?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/leaves/create`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to log employee leave.",
      errors: error?.response?.data?.errors,
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeleteLeave = async (id: string): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/leaves/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete leave log.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
